import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { BuiltInModule } from '../../built-in/built-in.module';

import { AddCreditComponent } from './add-credit/add-credit.component';
import { FullyPaidMembersComponent } from './fully-paid-members/fully-paid-members.component';
import { JlUpdatePaymentPlanComponent } from './jl-update-payment-plan/jl-update-payment-plan.component';
import { LogPaymentComponent } from './log-payment/log-payment.component';
import { MakeQuickPaymentComponent } from './make-quick-payment/make-quick-payment.component';
import { PastDueMembersComponent } from './past-due-members/past-due-members.component';
import { PaymentTypeComponent } from './payment-type/payment-type.component';
import { PlayerDiscountComponent } from './player-discount/player-discount.component';
import { RegisteredMembersComponent } from './registered-members/registered-members.component';
import { ScholarshipInformationComponent } from './scholarship-information/scholarship-information.component';
import { UpdatePaymentPlanComponent } from './update-payment-plan/update-payment-plan.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BuiltInModule,
  ],
  declarations: [
    AddCreditComponent,
    MakeQuickPaymentComponent,
    ScholarshipInformationComponent,
    PlayerDiscountComponent,
    UpdatePaymentPlanComponent,
    RegisteredMembersComponent,
    FullyPaidMembersComponent,
    PastDueMembersComponent,
    LogPaymentComponent,
    PaymentTypeComponent,
    JlUpdatePaymentPlanComponent
  ],
  exports: [
    AddCreditComponent,
    MakeQuickPaymentComponent,
    ScholarshipInformationComponent,
    PlayerDiscountComponent,
    UpdatePaymentPlanComponent,
    RegisteredMembersComponent,
    FullyPaidMembersComponent,
    PastDueMembersComponent,
    LogPaymentComponent,
    PaymentTypeComponent,
    JlUpdatePaymentPlanComponent
  ]
})
export class MemberBillingInfoModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/member-billing-info.module.ts